// Emite un evento a GA4 (gtag) y, si existe, al dataLayer de GTM.
// No-op en SSR / si analytics no cargó.
export function track(name, params = {}) {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  } else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
  }
}

export const analytics = {
  ctaClick: (label, location) =>
    track('cta_click', { cta_label: label, cta_location: location }),

  contactRequest: (source) => track('contact_request', { source }),

  contactSubmit: (source) => track('contact_form_submit', { source }),

  whatsappClick: (source) => track('whatsapp_click', { source }),

  custom: (name, params = {}) => track(name, params),
};
